// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__e7RRH","name":"styles_name__b0GL8","phone":"styles_phone__lTULo"};